import React from 'react';
import {Link} from 'react-router-dom';
import {UiuxMakkiah} from '../../components/UIUX/uiux';

const MakkiahPage = () => {
  return (
    <div className='uiux-p-wrapper'>
        <h1 className='uiux-p-header'>UI/UX - Makkiah.com</h1>
        <div className='uiux-p-single'>
          <br/>
          <p className='uiux-p-single-text'>Check back soon for more information.</p>
          <br/>
          <p className='uiux-p-single-subtext'>View Figma designs by clicking the dropdown menu in the top-left corner below.</p>
          <br/>
          <Link to="/uiux" className="fa-solid fa-arrow-left uiux-p-single-back" key="back"></Link>            
          < UiuxMakkiah />
        </div>
    </div>
  )
}

export default MakkiahPage;